import axiosInstance from "../../api/axiosInstance";

/**
 * Create a squad banner (store item type banner) with header and background images.
 * @param {FormData} formData - type, key, name, nameAr, availableFor, unlockType, isPaid, price, currency, isActive, isDefaultForSquad, isDefaultForUser, sortOrder, rarity, season, header (file), background (file)
 */
export const createSquadBannerAPI = async (formData) => {
  const res = await axiosInstance.post("storeItems/create", formData);
  return res.data;
};
